import React, { Component} from 'react'
import classnames from 'classnames';
import IScroll from 'iscroll/build/iscroll-probe.js';
class Scroll extends Component {
  constructor(props) {
    super(props);
    this.wH = document.documentElement.clientHeight||window.innerHeight;
    this.state = {
      myScroll: null,
      minHeight:this.wH-150,
      downStatus:0,
      upStatus:0,
      initSuccess:false //初始化完成 默认false
    };
     this.pullDownTips = {
        // 下拉状态
        0: '下拉刷新',
        1: '松手刷新',
        2: '正在刷新',
        3: '刷新成功',
    };

    this.pullUpTips = {
        // 上拉状态
        0: '上拉加载',
        1: '松手加载',
        2: '正在加载',
        3: '加载成功',
    };
    this.downFlag = false;
    this.upFlag = false;
    this.fetchComplete =this.fetchComplete.bind(this);
    this.fetchJsons =this.fetchJsons.bind(this);

    /*
     * this.props 参数说明
     * openDown = true 开启 下拉刷新  ，默认 false 
     * openUp = true 开启 上拉加载更多  ，默认 false 
     * allowScroll 允许滚动 ，这里的滚动，指的是页面全局的滚动，默认 true ,
     * downFetch '下拉刷新' 达到条件调用的方法 ,
     * upFetch '上拉加载更多' 达到条件调用的方法 ,
     * isRefresh '下拉、上拉 加载完成' 更新视图 , 默认false ,fetch调用完成时请更新为true
     * onScroll iscroll滚动时的信息监听，默认无
    */

  }

  componentDidMount() {
    setTimeout( () => {
      this.state.myScroll = new IScroll(this.refs.scrollWrapper, { 
        mouseWheel: true,
        probeType: 3,
        bounce: true,
        preventDefault: false,
        disablePointer: false,
        scrollbars: this.props.scrollbar,
      });

      this.stopTouchmove = (e) => { 
        e.preventDefault();
      };
      this.state.myScroll.on('scroll', () => {
        
        let {myScroll,downStatus,upStatus}=this.state;
        let {openDown,openUp} = this.props;
        let y = myScroll.y,
        maxY = myScroll.maxScrollY - y;
        //下拉刷新 的监听
        if(openDown){
          if(y >= 45){
              if(!downStatus){
                this.setState({
                  downStatus:1
                })
              }
              return false;
          }else if(y < 45 && y > 0 && !this.downFlag){
              if(downStatus){
                this.setState({
                  downStatus:0
                })
              }
              return false;
          }
        };

         //上拉加载 的监听
        if(openUp){
          if(maxY >= 45){
            if(!upStatus){
              this.setState({
                upStatus:1
              })
            }
            return false;
          }else if(maxY < 45 && maxY >=0 && !this.upFlag){
            if(upStatus){
              this.setState({
                upStatus:0
              })
            }
            return false;
          };
        };
        this.props.onScroll && this.props.onScroll(this.state.myScroll);
      });

      //监听 touchend 结束的事件
      (this.refs.scrollWrapper).addEventListener('touchend', () => {
        let {downStatus,upStatus,myScroll}=this.state;
        let {openDown,openUp,downFetch,upFetch} = this.props;

        if(openDown||openUp){

          //下拉刷新
          console.log("down touchend",this.state.downStatus,myScroll.directionY);
          if(downStatus == 1 && myScroll.directionY <=1){
            this.downFlag = true;
            this.setState({downStatus:2});
       
            // this.state.myScroll.scrollTo(0, -1 * 40, 200);
            downFetch&&this.fetchJsons(downFetch);
            // downFetch&&downFetch(this.fetchComplete).then(()=>{
            //   __DEBUG__ && console.log("openDown 请求完成");
            //   this.fetchComplete();
            // });
          }else if(upStatus == 1 && myScroll.directionY <= 1){//上拉加载
            this.upFlag = true;
            this.setState({upStatus:2});
            // this.state.myScroll.scrollTo(0, myScroll.maxScrollY + 80, 150);
            upFetch&&this.fetchJsons(upFetch);
            // upFetch&&upFetch(this.fetchComplete).then(()=>{
            //   __DEBUG__ && console.log("openUp 请求完成");
            //   this.fetchComplete();
            // });
            // console.log("up - touchend",this.state.upStatus);
          }

        };
      }); 
      let allowScroll = this.props.allowScroll;
      if(!allowScroll){
        (this.refs.scrollWrapper).addEventListener('touchmove', this.stopTouchmove); 
        document.addEventListener('touchmove', this.stopTouchmove); 
      };
      this.ininData();
    }, 250);

  }
  fetchJsons(callBack){
    /*
      调用下拉、上拉 方法，统一处理回调 
     * downFetch '下拉刷新'  ,
     * upFetch '上拉加载更多'  ,
    */
    var re = /function\s*(\w*)/i;
    var matches = re.exec(`${callBack}`);
    callBack&&callBack(this.fetchComplete).then(()=>{
      
      __DEBUG__ && console.log(`${matches&&matches[0]} --- 请求完成`);
      this.fetchComplete();
    },()=>{
      __DEBUG__ && console.log(`${matches&&matches[0]} --- 请求异常`);
      this.fetchComplete();
    })
  }
  ininData(){
    /*
      *初始化时 检测，如有设置，默认调用一次下拉、或下拉方法，加载数据
    */
    let {openDown,openUp,downFetch,upFetch} = this.props;

    if(openDown && downFetch){
      this.fetchJsons(downFetch);
        // downFetch(this.fetchComplete).then(()=>{
        //   __DEBUG__ && console.log("openDown 请求完成");
        //   this.fetchComplete();
        // })
    }else if(openUp&&upFetch){
      this.fetchJsons(upFetch);
      // upFetch(this.fetchComplete).then(()=>{
      //   __DEBUG__ && console.log("openUp 请求完成");
      //   this.fetchComplete();
      // });
    }else{
      this.fetchComplete()
    };
  }
  manualTouchMove(allowScroll){    
      if(allowScroll){
        document.removeEventListener('touchmove', this.stopTouchmove);                             
      }else{
        document.addEventListener('touchmove', this.stopTouchmove); 
      }
  }
  fetchComplete(){
    //fetch 完成时的请求回调
    let {downStatus,upStatus,myScroll}=this.state;
    let minH = (this.refs.scrollWrapper&&this.refs.scrollWrapper.clientHeight||(this.wH-150))+5;
    if(downStatus == 2 || this.downFlag){
      this.setState({
        downStatus:3,
        minHeight:minH
      });
    }else if(upStatus == 2 || this.upFlag){
      this.setState({
        upStatus:3,
        minHeight:minH
      });
    }else{
      this.setState({
        downStatus:3,
        minHeight:minH,
        initSuccess:true
      });
    }
  }
  componentDidUpdate(prevProps) {
    let {openDown,openUp,isRefresh} = this.props;
    let {downStatus,upStatus,myScroll}= this.state;
    let preRefresh = prevProps.isRefresh;
    //未开启 上拉、下拉 时 自动更新
    if(!openDown&&!openUp){
      setTimeout(() => {
        myScroll.refresh();
      }, 350);
    }else if(openDown || openUp ){
      if(downStatus == 3){
        this.setState({downStatus:0});
        setTimeout(() => {
          myScroll.refresh();
          this.downFlag=false;
          __DEBUG__ && console.log("dow 视图更新了")
        }, 350);
      }else if(upStatus == 3){
        this.setState({upStatus:0});
        setTimeout(() => {
          myScroll.refresh();
          this.upFlag=false;
          __DEBUG__ && console.log("up 上拉加载 视图更新了")
        }, 350);
      }else if(isRefresh!=preRefresh){
        setTimeout(() => {
          myScroll.scrollTo(0,0);
          myScroll.refresh();
        }, 350);
      };
    }
  }

  componentWillReceiveProps(nextProps) {
    this.manualTouchMove(nextProps.allowScroll);
    if(nextProps.refresh) {
      setTimeout(() => {
          this.state.myScroll && this.state.myScroll.refresh();
      }, 150);
    }
    const { ScrollToY } = nextProps;

    if(!ScrollToY || this.updateY == nextProps.updateY) {
      return;
    }

    this.updateY = nextProps.updateY;

    this.state.myScroll.scrollTo(0, -ScrollToY, 500)
  }

  componentWillUnmount() {
    (this.refs.scrollWrapper).removeEventListener('touchmove', this.stopTouchmove); 
    (this.refs.scrollWrapper).removeEventListener('touchend', this.stopTouchmove); 
    document.removeEventListener('touchmove', this.stopTouchmove);
  }

  render() {    
    let {downStatus,upStatus,initSuccess,minHeight}=this.state;
    const props = this.props;
    const { children, className,openDown,openUp, ...others } = props;
    return (
      <div className="scroll-wrapper" ref="scrollWrapper">
        <div className="scroller">
        {
        openDown?(
          <div className={classnames("s-pullDown",{'init':initSuccess})}>
            <em className={classnames("scroll-svg",{[`step${downStatus}`]:true})}>&#12288;</em>
            <em className="scroll-msg">{this.pullDownTips[downStatus]}</em>
          </div>
        ):null
        }
        <div className="iscroll-child" style={{minHeight:minHeight}}>{ children }</div>
        {
        openUp?(
          <div  className= {classnames("s-pullUp",{'init':initSuccess})} >
            <em className={classnames("scroll-svg",{[`step${upStatus}`]:true})}>&#12288;</em>
            <em className="scroll-msg">{this.pullUpTips[upStatus]}</em>
          </div>
        ):null
        }
        </div>
      </div>
    )
  }
};


export default Scroll



// WEBPACK FOOTER //
// ./components/Scroll/Scroll.js